import _ from 'lodash';

const PAGE_SIZE = 20;

export default {
  data() {
    return { matchRequestVersion: 0, isLoadingMore: false, matchesLoadError: false };
  },
  methods: {
    getRoundLabel(round, meta) {
      return _.get(round, 'abbreviation') || _.get(round, 'displayName') || _.get(meta, 'name') ||
        (round && round.number !== undefined && round.number !== null && round.number !== ''
          ? `Round ${round.number}` : '');
    },
    async loadMatches({ reset = false, updateRounds = true, where } = {}) {
      if (!reset && (this.processMatchesFlag || this.isLoadingMore || this.isDisabled)) return;
      this.matchesLoadError = false;
      if (reset) {
        // Older filter responses must not modify this list or its loading state.
        this.matchRequestVersion++;
        this.processMatchesFlag = true;
        this.isLoadingMore = false;
        this.page = 0;
        this.totalMatches = 0;
        this.competitionsWithMatches = [];
        this.isDisabled = false;
      } else {
        this.isLoadingMore = true;
      }
      const version = this.matchRequestVersion;
      const nextPage = this.page + 1;
      try {
        const response = await this.getMatches(where, nextPage);
        if (version !== this.matchRequestVersion) return;
        const payload = _.get(response, 'data.data');
        if (!payload || !Array.isArray(payload.pageData) || !Number.isFinite(payload.total)) {
          throw new Error('Invalid matches response');
        }
        this.competitionsWithMatches = _.sortBy(
          _.uniqBy([...this.competitionsWithMatches, ...payload.pageData.flat()], '_id'),
          'dateTime'
        );
        this.page = nextPage;
        this.totalMatches = payload.total;
        this.isDisabled = this.page >= Math.ceil(payload.total / PAGE_SIZE);
        if (reset && updateRounds) {
          this.rounds = payload.availableRounds || [];
          this.availableDays = payload.availableDays || [];
        }
      } catch (error) {
        if (version !== this.matchRequestVersion) return;
        // Keep the current page and allow retry after a failed request.
        this.isDisabled = false;
        this.matchesLoadError = true;
        console.error('Unable to load matches:', error);
      } finally {
        if (version === this.matchRequestVersion) {
          this.processMatchesFlag = false;
          this.isLoadingMore = false;
        }
      }
    },
  },
};
